// extracted by mini-css-extract-plugin
export default {"closingDate":"styles_closingDate__O+52U","date":"styles_date__ripM5","editIcon":"styles_editIcon__o5pCR"};